<div class="activate-rewards" *ngIf="isLoaded && trendsPoints === 0">
  <div class="title">
  <img src="assets/images/common/info.svg" />
  Unlock your Tier benefits
  </div>
  <div class="purchase">Shop at TRENDS, RCP store to unlock your Tier benefits. Make sure to show the cashier your Earn code. Purchases can take a few days to appear.</div>
  <div class="store" [routerLink]="'/earn-redeem'">
    Show my Earn QR code
  </div>
</div>
